import {
  ADD_PRODUCT,
  DECREASE_PRODUCT_QUANTITY,
  INCREASE_PRODUCT_QUANTITY,
  RETURN_QTY_AFTER_CART_DLT,
} from "./actionType";
import { initialState } from "./initialState";

const nextProductId = (products) => {
  const maxId = products.reduce(
    (maxId, product) => Math.max(product.id, maxId),
    -1
  );

  return maxId + 1;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      return [
        ...state,
        {
          id: nextProductId(state),
          ...action.payload,
        },
      ];

    case DECREASE_PRODUCT_QUANTITY:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            quantity: product.quantity - 1,
          };
        }
        return product;
      });

    case INCREASE_PRODUCT_QUANTITY:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            quantity: product.quantity + 1,
          };
        }
        return product;
      });

    case RETURN_QTY_AFTER_CART_DLT:
      return state.map((product) => {
        if (product.id === action.payload.productId) {
          return {
            ...product,
            quantity: product.quantity + action.payload.quantity,
          };
        }
        return product;
      });

    default:
      return state;
  }
};

export default reducer;
